import sanityImageUrlBuilder from '@sanity/image-url'
import { getClient } from './getClient'

export const imageUrlBuilder = sanityImageUrlBuilder(getClient(false))
